import type { FaireProductEntity } from "../../entity_types/product";

export const p_6lnp97x: FaireProductEntity = {
  token: "p_6lnp97x",
  type: "product",
  name: "Waffle Cone Chunky Chocolate Bar",
  brandName: "Fine & Raw Chocolate",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/901677914a087daf37d3ba0d2491608f5c577da7df9c429056eae062d6ad59a1.webp",
  priceDollars: 8.5,
  description:
    "Organic chocolate bar with waffle cone pieces - handmade in Brooklyn",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "chocolate", "brooklyn"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/901677914a087daf37d3ba0d2491608f5c577da7df9c429056eae062d6ad59a1.webp",
  weight: 0.4,
  dimensions: {
    width: 3,
    height: 5,
    depth: 0.5,
  },
  inStock: true,
};
